import { Component, Inject, OnInit } from '@angular/core';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { CommonUtilService, SalesforceService } from '../../services';

@Component({
  selector: 'app-re-connect-setting',
  templateUrl: './re-connect-setting.component.html',
  standalone: false,
})
export class ReConnectSettingComponent implements OnInit {
    matchIds = null;
    authProvider;
    isFromList;

    constructor(
        public commonUtilService: CommonUtilService,
        public salesforceService: SalesforceService,
        private readonly matDialogRef: MatDialogRef<ReConnectSettingComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) { }

    ngOnInit() {
        this.authProvider = this.data.provider;
        if (this.data.match_ids) {
            this.matchIds = this.data.match_ids;
        }
        this.isFromList = (this.data.ifFromList) ? this.data.ifFromList : '';
    }

    onReconnect() {
        if (this.data.provider) {
            if (this.authProvider === 'salesforce') {
                this.salesforceService.isReconnect = true;
            }
            if (this.authProvider === 'salesforce_company') {
                this.salesforceService.isReconnectCompany = true;
            }
            this.commonUtilService.openOauthCRM(this.authProvider, this.matchIds, this.isFromList);

            this.onClose();
        }
    }

    onClose(): void {
        this.matDialogRef.close();
    }
}
